import type { GradeCode } from '~/models/Grade'
import stringUtils from './stringUtils'

const { lastInPath } = stringUtils()

export const GRADE1 = 'aarstrinn1'
export const GRADE2 = 'aarstrinn2'
export const GRADE3 = 'aarstrinn3'
export const GRADE4 = 'aarstrinn4'
export const GRADE5 = 'aarstrinn5'
export const GRADE6 = 'aarstrinn6'
export const GRADE7 = 'aarstrinn7'
export const GRADE8 = 'aarstrinn8'
export const GRADE9 = 'aarstrinn9'
export const GRADE10 = 'aarstrinn10'
export const GRADE11 = 'vg1'
export const GRADE12 = 'vg2'
export const GRADE13 = 'vg3'
export const GRADE_ADULT = 'vok'
export const GRADE_PREP = 'prep'

export const gradesSorted: GradeCode[] = [
  GRADE1,
  GRADE2,
  GRADE3,
  GRADE4,
  GRADE5,
  GRADE6,
  GRADE7,
  GRADE8,
  GRADE9,
  GRADE10,
  GRADE11,
  GRADE12,
  GRADE13,
  GRADE_ADULT,
  GRADE_PREP,
]

export const elementaryLowerGrades: GradeCode[] =  [GRADE1, GRADE2, GRADE3, GRADE4]
export const elementaryUpperGrades: GradeCode[] = [GRADE5, GRADE6, GRADE7]
export const middleSchoolGrades: GradeCode[] = [GRADE8, GRADE9, GRADE10]
export const highSchoolGrades: GradeCode[] = [GRADE11, GRADE12, GRADE13]
export const adultSchoolGrades: GradeCode[] = [GRADE_ADULT]
export const prepSchoolGrades: GradeCode[] = [GRADE_PREP]

export const elementaryGrades: GradeCode[] = elementaryLowerGrades.concat(elementaryUpperGrades)
export const combinedGrades: GradeCode[] = elementaryGrades.concat(middleSchoolGrades).concat(highSchoolGrades)
export const lowerGrades: GradeCode[] = elementaryGrades.concat(middleSchoolGrades)
export const higherGrades: GradeCode[] = middleSchoolGrades.concat(highSchoolGrades)

export const highSchoolAdultAndPrepGrades = [
  ...highSchoolGrades,
  ...adultSchoolGrades,
  ...prepSchoolGrades,
]

export const findRelevantGrades = (grade: GradeCode) => {
  if (elementaryLowerGrades.includes(grade)) return elementaryLowerGrades
  if (elementaryUpperGrades.includes(grade)) return elementaryUpperGrades
  if (middleSchoolGrades.includes(grade)) return middleSchoolGrades
  if (highSchoolGrades.includes(grade)) return highSchoolGrades
  if (adultSchoolGrades.includes(grade)) return adultSchoolGrades
  if (prepSchoolGrades.includes(grade)) return prepSchoolGrades
  return []
}

export const sortByGradeIndex = (gradeCodeA: GradeCode | string, gradeCodeB: GradeCode | string): number => {
  return gradesSorted.indexOf(lastInPath<GradeCode>(gradeCodeA)) - gradesSorted.indexOf(lastInPath<GradeCode>(gradeCodeB))
}

export const sortByLowestGrade = (a: any, b: any): number => {
  if (!a.grades || !b.grades) return 0
  if (a.grade && b.grade) return sortByGradeIndex(a.grade, b.grade)
  const gradesA: GradeCode[] | string[] = a.grades
  const gradesB: GradeCode[] | string[] = b.grades

  const lowestGradeA = gradesA.sort(sortByGradeIndex)[0]
  const lowestGradeB = gradesB.sort(sortByGradeIndex)[0]

  return sortByGradeIndex(lowestGradeA, lowestGradeB)
}
